import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FC } from "react";

interface ThriveTitleProps {
  title: string;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
}

const ThriveTitle: FC<ThriveTitleProps> = ({ title, setOpen, onClose }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#9E1F63FF",
        padding: "3px",
        margin: 0,
        color: "white",
        borderRadius: "5px 5px 0 0",
      }}
    >
      <Typography
        sx={(theme) => ({
          display: "inline-block",
          // Phones: a smaller title keeps it on one line beside the close icon.
          [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
            lineHeight: "40px",
          },
        })}
        variant="h4"
      >
        {title}
      </Typography>
      <Box
        sx={{ display: "inline", float: "right", cursor: "pointer" }}
        onClick={() => {
          setOpen(false);
          if (onClose) {
            onClose();
          }
        }}
      >
        <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
      </Box>
    </Box>
  );
};

export default ThriveTitle;
